"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERNAL_EMAIL_DOMAINS = void 0;
exports.isInternalUser = isInternalUser;
exports.INTERNAL_EMAIL_DOMAINS = ['@blackcrow.ai', '@viddyapp.io'];
/**
 * Internal storefront staff, by email domain. Single source of truth for both
 * the backend guard (InternalUserAuthorizedGuard) and frontend visibility
 * checks — the two must never drift.
 */
function isInternalUser(username) {
    const email = (username !== null && username !== void 0 ? username : '').toLowerCase();
    return exports.INTERNAL_EMAIL_DOMAINS.some((domain) => email.endsWith(domain));
}
